<template>
    <div class="flex-array-h">
        <base-form-view class="width-parent-48 conditionBox margin-top-16" :out-data="condition"
                        @onValueChange="onConditionSelect"/>
        <div v-for="(item,index) in children" :key="index" :class="getItemWidth(item)">
            <div :is="conditionView" :condition-data="item"
                 v-if="item.type === 'condition-picker' || item.type === 'condition-select' ||item.type === 'conditionView'"
                 @onConditionDataChange="onConditionChange(item,$event)"/>
            <div :is="groupView" v-else-if="item.type=== 'group'" :group-data="item"
                 @groupChildrenChange="groupDataChange(item,$event)"/>
            <!--            <base-form-view v-else :out-data="item" @onValueChange="onFormValueChange(item,$event,children)"/>-->
            <div v-else :out-data="item" @onValueChange="onFormValueChange(item,$event,children)" :is="groupEssential"></div>
        </div>
    </div>
</template>

<script>

    import BaseFormView from "../../formView";
    import FormGroupView from "../../formGroupView";
    import ConditionSelectView from "../../conditionSelectView";
    export default {
        name: 'conditionDynamicView',
        components: {FormGroupView, BaseFormView, ConditionSelectView},
        data() {
            return {
                condition: {},// 条件
                children: [],// 子view
                value: null,
                dropdownName: null,// 下拉列表的字符串-新增
                opinions: [],
                conditionView: '',
                groupView: '',
                groupEssential: ''
            }
        },
        props: {
            conditionData: {
                type: Object,
                default() {
                    return {};
                }
            },
        },
        watch: {
            conditionData: {
                handler(newValue) {
                    // 条件数据发生变化
                    console.log('检测到条件view数据变化-newConditionData=', newValue);
                    if (newValue.children) {
                        let newCaching = JSON.parse(localStorage.getItem('restaurants'));
                        let currentChild = newValue.children
                        currentChild.forEach(ref => {
                            let parameter = {}
                            let newIndex
                            ref.forEach(res => {
                                parameter[res.key] = res.value
                            })
                            if (parameter['name']) {
                                newIndex = newCaching.findIndex(item => {
                                    return item.name == parameter['name']
                                })
                            }
                            if (newIndex != -1 && newIndex != undefined) {
                                newCaching[newIndex] = parameter
                            } else if (newIndex === -1) {
                                newCaching.push(parameter)
                            }
                        })
                        localStorage.setItem('restaurants', JSON.stringify(newCaching))
                    }

                    this.analysisData(newValue);
                },
                immediate: true,
                deep: true
            },
        },
        computed: {},
        mounted() {
            this.conditionView = resolve => {
                require([`../../conditionSelectView`], resolve)
            }
            this.groupView = resolve => {
                require([`../../formGroupView`], resolve)
            }
            this.groupEssential = resolve => {
                require([`../../formView`], resolve)
            }
        },
        methods: {
            async analysisData(newData) {
                // let parse = JSON.parse(JSON.stringify(newData));
                console.log("analysisData-newData=", newData);
                let {label, value, required, opinions, items, children, dropdownName} = newData;
                this.items = items;
                this.value = value;
                this.children = children[0];
                this.dropdownName = dropdownName;
                this.opinions = opinions;
                this.condition = {
                    label, value, required, opinions,
                    type: 'select'
                }
                if (value && this.$verify.isEmptyArray(this.children)) {
                    this.onConditionSelect(value);
                }

                console.log('this.conditionData=', this.conditionData, '-label=', this.conditionData.label);

                if (this.$verify.isEmptyArray(this.children)){
                    this.children = children[0];
                }else {
                    this.children = [];
                    this.$forceUpdate();
                    this.$nextTick(()=>{
                        this.children = children[0];
                    });
                }
            },
            groupDataChange(groupData, children) {

                console.log('groupDataChange-groupData', groupData, '-children=', children)
                this.$set(groupData, 'children', children);
                this.notifyDataChange();
            },
            onFormValueChange(item, newValue, currentChild) {

                let newCaching = JSON.parse(localStorage.getItem('restaurants'));
                // 这种是conditionView的children全是formView那种
                if (Object.prototype.toString.call(newValue) !== '[object Object]') {
                    this.$set(item, 'value', newValue);
                    let parameter = {}
                    let newIndex
                    currentChild.forEach(res => {
                        parameter[res.key] = res.value
                    })
                    if (parameter['name'] && item.label!=="收件人") {
                        newIndex = newCaching.findIndex(item => {
                            return item.name == parameter['name']
                        })
                    }
                    if (newIndex != -1 && newIndex != undefined) {
                        newCaching[newIndex] = parameter
                    } else if (newIndex === -1) {
                        newCaching.push(parameter)
                    }
                    localStorage.setItem('restaurants', JSON.stringify(newCaching))
                } else {
                    console.log(newValue,'数据结构层次看看')
                    console.log(currentChild,'循环的结果')
                    for (let key in newValue) {
                        currentChild.forEach(item => {
                            if (key === item.key) {
                                item.value = newValue[key]
                                this.$set(item, 'value', newValue[key]);
                            }else {
                                if(item.key==='telePhone'&& key=='telphone'){
                                    item.value = newValue[key]
                                    this.$set(item, 'value', newValue[key]);
                                }
                            }
                        })
                    }
                    this.groupEssential = ''
                    this.groupEssential = resolve => {
                        require([`../../formView`], resolve)
                    };
                }
                this.notifyDataChange();
            },
            onConditionSelect(conditionValue) {

                // conditionValue为当前条件选择的值
                this.value = conditionValue;
                // // 找到当前选择的option-然后更新dropdownName
                // console.log("onConditionSelect-this.opinions=",this.opinions);
                // console.log("onConditionSelect-conditionValue=",conditionValue);
                // if (!this.$verify.isEmptyArray(this.opinions)){
                //     let findOne = this.opinions.find(option => option.value === conditionValue);
                //     console.log("onConditionSelect-findOne=",findOne);
                //     if (!this.$verify.isEmpty(findOne)) {
                //         this.dropdownName = findOne.label;
                //     }
                // }

                console.log("onConditionSelect-conditionValue发生改变-值:",conditionValue);

                this.children = this.items.filter(v => {
                    return v.conditionValue == conditionValue;
                });

                if (this.children.length != 0 || conditionValue === 'NONE') {
                    this.notifyDataChange();
                }


            },
            onConditionChange(item, newItem) {

                console.log('item=', item)
                console.log('newItem=', newItem)

                // 将newItem中改变的值赋值给item
                for (const newItemKey in newItem) {
                    if (newItem.hasOwnProperty(newItemKey)) {
                        let value = newItem[newItemKey];
                        if (item.hasOwnProperty(newItemKey) && item[newItemKey] === value) {
                            continue;
                        }
                        this.$set(item, newItemKey, value);
                    }
                }
                this.notifyDataChange();
            },
            notifyDataChange() {
                // 组装数据
                let copy = JSON.parse(JSON.stringify(this.conditionData));
                copy.value = this.value;
                // 2022-8-16日新增需求-根据身份证-改变其性别
                let handleChildren = this.$dynamicTool.transaction.handleDynamicChildren(this.children);
                if (this.$verify.isEmptyArray(handleChildren)){
                    copy.children = [this.children];
                    this.$emit('onConditionDataChange', copy);
                    return;
                }
                copy.children = [handleChildren];
                this.$emit('onConditionDataChange', copy);
            },
            getItemWidth(formItem) {
                let style = 'margin-top-8';
                switch (formItem.type) {
                    case 'conditionView':
                    case 'condition-picker':
                    case 'group':
                        style += ' match-parent-w';
                        break
                    default:
                        style += ' width-parent-48';
                        break
                }
                return style;
            }
        }

    }
</script>

<style scoped lang="scss">
</style>
